import { render, staticRenderFns } from "./ArchiveScheduledPaymentAction.vue?vue&type=template&id=96044040&scoped=true"
import script from "./ArchiveScheduledPaymentAction.vue?vue&type=script&lang=js"
export * from "./ArchiveScheduledPaymentAction.vue?vue&type=script&lang=js"
import "./ArchiveScheduledPaymentAction.vue?vue&type=style&index=0&id=96044040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96044040",
  null
  
)

export default component.exports